import { render, staticRenderFns } from "./TreatSectionHeader.vue?vue&type=template&id=cacc9e86&scoped=true"
import script from "./TreatSectionHeader.vue?vue&type=script&lang=js"
export * from "./TreatSectionHeader.vue?vue&type=script&lang=js"
import style0 from "./TreatSectionHeader.vue?vue&type=style&index=0&id=cacc9e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacc9e86",
  null
  
)

export default component.exports